export default "https://cdn-static.gokick.com/assets/0b66121a981ee5d829a48c6e4fd91363599ac59b/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";